import React, { useState } from "react";
import { Document, Page, pdf } from "@react-pdf/renderer";
import Button from "@material-ui/core/Button";
import { GrDocumentPdf } from "react-icons/gr";
import { LuX } from "react-icons/lu";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import PdfHeader from "../PortInformation/pdfHeader";
import PdfFooter from "../PortInformation/pdfFooter";
import LaytimeStatementPDF from "./LaytimeStatementPdf";
import StatementOfFactsPdf from "./StatementOfFactsPdf";
import { toastError, toastSuccess } from "../../../utils";

export const DownloadPdf = (props) => {
  const { pdfData, isLaytimeStatement = false, onDownloadElectricPdf } = props;
  const [open, setOpen] = useState(false);
  const [pdfName, setPdfName] = useState(
    `${new Date().getTime().toString(16)}${Math.floor(
      Math.random() * 16777215
    ).toString(16)}${isLaytimeStatement ? "_LaytimeStatement" : "_SOF"}.pdf`
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const downloadFile = async () => {
    try {
      const { _id } = await onDownloadElectricPdf()
      const doc = (
        <Document>
          <Page
            size="A4"
            orientation={isLaytimeStatement ? "landscape" : "portrait"}
          >
            <PdfHeader />
            {isLaytimeStatement ? (
              <LaytimeStatementPDF laytimeStatementDetails={pdfData} pdfSaveId={_id} />
            ) : (
              <StatementOfFactsPdf state={pdfData} pdfSaveId={_id} />
            )}
            <PdfFooter />
          </Page>
        </Document>
      );

      const pdfBlob = await pdf(doc).toBlob();
      const url = window.URL.createObjectURL(pdfBlob);
      const element = document.createElement("a");
      element.href = url;
      element.setAttribute("download", pdfName);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      toastSuccess("PDF downloaded successfully");  
      handleClose()
    } catch (error) {
      toastError(error.message);
    }
  };

  const generatePdf = async () => {
    try {
      handleOpen();
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <div className="inline-flex">
      <button
        onClick={generatePdf}
        type="button"
        className="flex items-center gap-1.5 px-2.5 py-0.5 h-[22px] text-[11px] font-medium text-white bg-[#313C4C] border border-[#313C4C] rounded-none cursor-pointer hover:bg-[#0c2f50] transition-colors m-0"
      >
        <GrDocumentPdf size={12} />
        <span>Download PDF</span>
      </button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="pdf-guide-title"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 32px)",
            maxWidth: "620px",
            maxHeight: "calc(100vh - 32px)",
            backgroundColor: "#ffffff",
            boxShadow: "0px 10px 30px rgba(0,0,0,0.2)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            outline: "none",
          }}
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-[#f8fafc]">
            <h2 id="pdf-guide-title" className="text-base font-semibold text-[#313C4C]">
              Download {isLaytimeStatement ? "Laytime Statement" : "Statement of Facts"} PDF
            </h2>
            <button
              type="button"
              onClick={handleClose}
              aria-label="Close"
              className="p-2 rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 transition-colors"
            >
              <LuX className="h-5 w-5" />
            </button>
          </div>

          <div className="min-h-0 overflow-y-auto px-4 py-4 text-[12px] text-slate-700">
            <div className="border border-slate-200 bg-slate-50 px-3 py-3">
              <div className="font-semibold text-slate-900 mb-1">What is this PDF?</div>
              <p>A printable copy of the {isLaytimeStatement ? "Laytime Statement" : "Statement of Facts"} exactly as it is filled in right now.</p>
            </div>
            <div className="font-semibold text-slate-900 mt-4 mb-2">How to use it</div>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Check that all details in the form are complete and correct.</li>
              <li>Click <strong>Download PDF</strong> below to save the file.</li>
              <li>Share or print the PDF as needed.</li>
              
            </ol>
            <div className="font-semibold text-slate-900 mt-4 mb-2">Where can I use this PDF?</div>
            <p className="mb-2">You can load the downloaded PDF into an operation so its {isLaytimeStatement ? "Laytime Statement" : "Statement of Facts"} is filled in from the file:</p>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Go to the <strong>Operations</strong> page and open the operation this {isLaytimeStatement ? "Laytime Statement" : "Statement of Facts"} belongs to.</li>
              <li>
                In the operation's cargo operation table, find the row you want and click <strong>View</strong> in the <strong>{isLaytimeStatement ? "Laytimes" : "Statement of Facts"}</strong> column
                {isLaytimeStatement ? " (View is shown on Loading rows only)." : "."}
              </li>
              <li>A <strong>{isLaytimeStatement ? "Laytime Statement" : "Statement of Facts"}</strong> window opens. Click <strong>Upload PDF</strong> at the top of that window and choose the PDF you downloaded.</li>
            </ol>
          </div>

          <div className="flex justify-end gap-2 px-4 py-3 border-t border-slate-200 bg-white">
            <Button onClick={handleClose} variant="outlined">
              Close
            </Button>
            <Button onClick={downloadFile} variant="contained" color="primary">
              Download PDF
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};